import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef, useEffect, useCallback } from 'react';
import api from '../api/axiosConfig';
import { Form, Container, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { message } from 'antd';
import { normalizeKoreanText } from '../utils/fixKoreanText';
const normalizeCourierName = (value) => normalizeKoreanText(String(value !== null && value !== void 0 ? value : '').trim());
const InvoiceValidation = () => {
    const [tracking_number, setTrackingNumber] = useState('');
    const [barcode, setBarcode] = useState('');
    const [result, setResult] = useState('');
    const [error, setError] = useState('');
    const [isValidating, setIsValidating] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [courierData, setCourierData] = useState({
        kyungdong: [],
        cheonil: [],
        hanjin: []
    });
    const [scannedTrackingNumbers, setScannedTrackingNumbers] = useState(new Set());
    const [scanHistory, setScanHistory] = useState(new Map());
    const [trackingSearch, setTrackingSearch] = useState('');
    const [showFailedOnly, setShowFailedOnly] = useState(false);
    const trackingInputRef = useRef(null);
    const barcodeInputRef = useRef(null);
    const debounceTimer = useRef(null);
    const isProcessingRef = useRef(false);
    const lastProcessedRef = useRef(''); // 마지막 처리 조합 추적
    // cleaned legacy comment
    const getLocalStorageKey = (date) => {
        const dateString = date.getFullYear() + '-' +
            String(date.getMonth() + 1).padStart(2, '0') + '-' +
            String(date.getDate()).padStart(2, '0');
        return `scan_history_${dateString}`;
    };
    // cleaned legacy comment
    const getLocalScanHistory = useCallback((date) => {
        try {
            const key = getLocalStorageKey(date);
            const stored = localStorage.getItem(key);
            if (stored) {
                const historyArray = JSON.parse(stored);
                const historyMap = new Map();
                historyArray.forEach(item => {
                    historyMap.set(item.tracking_number, item);
                });
                return historyMap;
            }
        }
        catch (error) {
            console.error('로컬 스토리지 조회 실패:', error);
        }
        return new Map();
    }, []);
    // cleaned legacy comment
    const cleanupOldLocalData = useCallback(() => {
        try {
            const today = new Date();
            const oneWeekAgo = new Date(today);
            oneWeekAgo.setDate(today.getDate() - 7);
            const keysToRemove = [];
            // cleaned legacy comment
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith('scan_history_')) {
                    // cleaned legacy comment
                    const dateString = key.replace('scan_history_', '');
                    const keyDate = new Date(dateString);
                    // cleaned legacy comment
                    if (keyDate < oneWeekAgo) {
                        keysToRemove.push(key);
                    }
                }
            }
            // cleaned legacy comment
            keysToRemove.forEach(key => {
                localStorage.removeItem(key);
            });
            if (keysToRemove.length > 0) {
            }
            else {
            }
        }
        catch (error) {
            console.error('로컬 스토리지 정리 중 오류:', error);
        }
    }, []);
    // cleaned legacy comment
    const getLocalStorageStats = useCallback(() => {
        try {
            let totalDays = 0;
            let totalRecords = 0;
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith('scan_history_')) {
                    totalDays++;
                    const stored = localStorage.getItem(key);
                    if (stored) {
                        const historyArray = JSON.parse(stored);
                        totalRecords += historyArray.length;
                    }
                }
            }
            return { totalDays, totalRecords };
        }
        catch (error) {
            console.error('로컬 스토리지 통계 조회 실패:', error);
            return { totalDays: 0, totalRecords: 0 };
        }
    }, []);
    // cleaned legacy comment
    const fetchScanHistory = useCallback(async (date) => {
        var _a;
        try {
            const dateString = date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0');
            let finalHistory = new Map();
            let finalScannedSet = new Set();
            let dbDataLoaded = false;
            try {
                // cleaned legacy comment
                const response = await api.get(`/api/scan-validation/history/${dateString}`, {
                    timeout: 15000,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) && response.data.data && Array.isArray(response.data.data)) {
                    // cleaned legacy comment
                    // cleaned legacy comment
                    const processedData = new Map();
                    response.data.data.forEach((item) => {
                        if (item.tracking_number) {
                            const existingItem = processedData.get(item.tracking_number);
                            if (!existingItem) {
                                // cleaned legacy comment
                                processedData.set(item.tracking_number, item);
                            }
                            else {
                                // cleaned legacy comment
                                if (item.validation_result === 'OK' && existingItem.validation_result === 'NG') {
                                    // cleaned legacy comment
                                    processedData.set(item.tracking_number, item);
                                }
                                else if (item.validation_result === 'NG' && existingItem.validation_result === 'OK') {
                                    // cleaned legacy comment
                                }
                                else {
                                    // cleaned legacy comment
                                    processedData.set(item.tracking_number, item);
                                }
                            }
                        }
                    });
                    // cleaned legacy comment
                    processedData.forEach((item, trackingNo) => {
                        finalHistory.set(trackingNo, item);
                        // cleaned legacy comment
                        if (item.validation_result === 'OK') {
                            finalScannedSet.add(trackingNo);
                        }
                        else {
                            // cleaned legacy comment
                            finalScannedSet.delete(trackingNo);
                        }
                    });
                    dbDataLoaded = true;
                    // cleaned legacy comment
                    setScanHistory(finalHistory);
                    setScannedTrackingNumbers(finalScannedSet);
                    message.success(`${dateString} DB 스캔 이력 ${finalHistory.size}건 로딩 완료 (성공: ${finalScannedSet.size}건)`);
                }
                else {
                    console.warn('DB에서 유효한 스캔 이력 데이터를 받지 못함');
                }
            }
            catch (apiError) {
                console.warn('DB 스캔 이력 조회 실패:', apiError);
                message.warning('DB 연결에 실패하여 로컬 데이터를 사용합니다.');
            }
            // cleaned legacy comment
            if (!dbDataLoaded) {
                const localHistory = getLocalScanHistory(date);
                if (localHistory.size > 0) {
                    // cleaned legacy comment
                    const processedLocalData = new Map();
                    localHistory.forEach((item, trackingNo) => {
                        const existingItem = processedLocalData.get(trackingNo);
                        if (!existingItem) {
                            // cleaned legacy comment
                            processedLocalData.set(trackingNo, item);
                        }
                        else {
                            // cleaned legacy comment
                            if (item.validation_result === 'OK' && existingItem.validation_result === 'NG') {
                                // cleaned legacy comment
                                processedLocalData.set(trackingNo, item);
                            }
                            else if (item.validation_result === 'NG' && existingItem.validation_result === 'OK') {
                                // cleaned legacy comment
                            }
                            else {
                                // cleaned legacy comment
                                processedLocalData.set(trackingNo, item);
                            }
                        }
                    });
                    // cleaned legacy comment
                    processedLocalData.forEach((item, trackingNo) => {
                        finalHistory.set(trackingNo, item);
                        if (item.validation_result === 'OK') {
                            finalScannedSet.add(trackingNo);
                        }
                        else {
                            // cleaned legacy comment
                            finalScannedSet.delete(trackingNo);
                        }
                    });
                    setScanHistory(finalHistory);
                    setScannedTrackingNumbers(finalScannedSet);
                    message.info(`${dateString} 로컬 스캔 이력 ${finalHistory.size}건 로딩 (성공: ${finalScannedSet.size}건 - DB 연결 확인 필요)`);
                }
                else {
                    // cleaned legacy comment
                    setScanHistory(new Map());
                    setScannedTrackingNumbers(new Set());
                    message.info(`${dateString} 스캔 이력이 없습니다.`);
                }
            }
            else {
                // cleaned legacy comment
            }
        }
        catch (error) {
            console.error('스캔 이력 조회 중 치명적 오류:', error);
            message.error('스캔 이력을 불러오는데 실패했습니다.');
            // cleaned legacy comment
            setScanHistory(new Map());
            setScannedTrackingNumbers(new Set());
        }
    }, [getLocalScanHistory]);
    // cleaned legacy comment
    const fetchOrdersByDate = useCallback(async (date) => {
        var _a;
        setIsLoadingData(true);
        try {
            // cleaned legacy comment
            cleanupOldLocalData();
            // 1. 스캔 이력과 주문 데이터를 동시에 조회
            const dateString = date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0');
            const [, response] = await Promise.all([
                fetchScanHistory(date),
                api.get(`/api/orders/seq`, {
                    params: { date: dateString }
                })
            ]);
            let orders = [];
            if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) && response.data.orders) {
                orders = response.data.orders;
            }
            if (orders.length > 0) {
                const groupedData = {
                    kyungdong: orders.filter((order) => {
                        const courierName = order.ship_comp || order.courier_company || order.courier || order.delivery_company || order.courier_name || '';
                        const normalized = normalizeCourierName(courierName);
                        return normalized.includes('경동') || courierName.includes('KD') || courierName.includes('kdexp');
                    }),
                    cheonil: orders.filter((order) => {
                        const courierName = order.ship_comp || order.courier_company || order.courier || order.delivery_company || order.courier_name || '';
                        const normalized = normalizeCourierName(courierName);
                        return normalized.includes('천일') || courierName.includes('CHUNIL') || courierName.includes('1000');
                    }),
                    hanjin: orders.filter((order) => {
                        const courierName = order.ship_comp || order.courier_company || order.courier || order.delivery_company || order.courier_name || '';
                        const normalized = normalizeCourierName(courierName);
                        return normalized.includes('한진') || courierName.includes('HANJIN') || courierName.includes('hanjin');
                    })
                };
                setCourierData(groupedData);
            }
            else {
                setCourierData({
                    kyungdong: [],
                    cheonil: [],
                    hanjin: []
                });
            }
        }
        catch (error) {
            console.error('주문 데이터 불러오기 실패:', error);
            message.error('주문 데이터를 불러오는데 실패했습니다.');
            setCourierData({
                kyungdong: [],
                cheonil: [],
                hanjin: []
            });
        }
        finally {
            setIsLoadingData(false);
        }
    }, [fetchScanHistory, cleanupOldLocalData]);
    // cleaned legacy comment
    useEffect(() => {
        // cleaned legacy comment
        cleanupOldLocalData();
        // cleaned legacy comment
        fetchOrdersByDate(selectedDate);
        // cleaned legacy comment
        const initializeSpeech = () => {
            if (window.speechSynthesis) {
                const initializeVoices = () => {
                    const voices = window.speechSynthesis.getVoices();
                    const koreanVoices = voices.filter(voice => voice.lang.includes('ko') ||
                        voice.name.includes('Korean') ||
                        voice.name.includes('한국'));
                    if (koreanVoices.length > 0) {
                        console.log('한국어 음성 엔진 로드 완료');
                    }
                };
                if (window.speechSynthesis.getVoices().length > 0) {
                    initializeVoices();
                }
                else {
                    window.speechSynthesis.onvoiceschanged = () => {
                        initializeVoices();
                        window.speechSynthesis.onvoiceschanged = null;
                    };
                    setTimeout(() => {
                        if (window.speechSynthesis.onvoiceschanged) {
                            window.speechSynthesis.onvoiceschanged = null;
                            initializeVoices();
                        }
                    }, 3000);
                }
            }
        };
        initializeSpeech();
    }, [selectedDate, fetchOrdersByDate, cleanupOldLocalData]);
    // cleaned legacy comment
    const handleDateChange = (date) => {
        if (date) {
            setSelectedDate(date);
        }
    };
    // cleaned legacy comment
    const getTrackingNumberStatus = useCallback((trackingNo) => {
        const history = scanHistory.get(trackingNo);
        if (!history)
            return null;
        return {
            result: history.validation_result,
            timestamp: history.scan_timestamp,
            error: history.error_message
        };
    }, [scanHistory]);
    // cleaned legacy comment
    const isTrackingNumberScanned = useCallback((trackingNo) => {
        // cleaned legacy comment
        const status = getTrackingNumberStatus(trackingNo);
        if (status) {
            return {
                isScanned: status.result === 'OK',
                isFailed: status.result === 'NG',
                status: status
            };
        }
        // cleaned legacy comment
        const isInSet = scannedTrackingNumbers.has(trackingNo);
        return {
            isScanned: isInSet,
            isFailed: false,
            status: null
        };
    }, [getTrackingNumberStatus, scannedTrackingNumbers]);
    const playBeepSound = useCallback(() => {
        try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.type = 'sine';
            // cleaned legacy comment
            const startTime = audioContext.currentTime;
            const cycleDuration = 0.8; // 0.8초 주기로 사이렌 반복
            const totalDuration = 10; // 총 10초
            // cleaned legacy comment
            for (let i = 0; i < totalDuration / cycleDuration; i++) {
                const cycleStart = startTime + (i * cycleDuration);
                const halfCycle = cycleDuration / 2;
                // cleaned legacy comment
                oscillator.frequency.setValueAtTime(300, cycleStart);
                oscillator.frequency.linearRampToValueAtTime(1500, cycleStart + halfCycle);
                // cleaned legacy comment
                oscillator.frequency.linearRampToValueAtTime(300, cycleStart + cycleDuration);
            }
            // 볼륨 설정 (최대 볼륨)
            gainNode.gain.setValueAtTime(1.0, startTime); // 최대 볼륨
            gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + totalDuration);
            oscillator.start(startTime);
            oscillator.stop(startTime + totalDuration);
        }
        catch (error) {
            // cleaned legacy comment
            const frequencies = [300, 500, 700, 900, 1100, 1300, 1500, 1300, 1100, 900, 700, 500]; // 사이렌 주파수 단계
            let currentIndex = 0;
            const playTone = (frequency, duration) => {
                const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                const oscillator = audioContext.createOscillator();
                const gainNode = audioContext.createGain();
                oscillator.connect(gainNode);
                gainNode.connect(audioContext.destination);
                oscillator.frequency.value = frequency;
                oscillator.type = 'sine';
                gainNode.gain.setValueAtTime(1.0, audioContext.currentTime); // 최대 볼륨
                oscillator.start();
                oscillator.stop(audioContext.currentTime + duration);
            };
            const sirenInterval = setInterval(() => {
                try {
                    playTone(frequencies[currentIndex], 0.12); // 조금 더 짧게
                    currentIndex = (currentIndex + 1) % frequencies.length;
                }
                catch (e) {
                    console.warn('Audio playback failed');
                    clearInterval(sirenInterval);
                }
            }, 120); // 조금 더 빠르게
            // cleaned legacy comment
            setTimeout(() => {
                clearInterval(sirenInterval);
            }, 10000);
        }
    }, []);
    // cleaned legacy comment
    const speakCourierName = useCallback((courierName) => {
        try {
            // cleaned legacy comment
            if (!window.speechSynthesis) {
                console.warn('음성 안내를 지원하지 않는 브라우저입니다');
                return;
            }
            // cleaned legacy comment
            window.speechSynthesis.cancel();
            // cleaned legacy comment
            const courierNameMap = {
                'kyungdong': '경동',
                'cheonil': '천일',
                'hanjin': '한진',
                'KD': '경동',
                'kdexp': '경동',
                'CHUNIL': '천일',
                '1000': '천일',
                'HANJIN': '한진'
            };
            // cleaned legacy comment
            let finalCourierName = courierName;
            for (const [key, value] of Object.entries(courierNameMap)) {
                if (courierName.includes(key)) {
                    finalCourierName = value;
                    break;
                }
            }
            // cleaned legacy comment
            const speechText = `${finalCourierName} 검증 완료`;
            const utterance = new SpeechSynthesisUtterance(speechText);
            // cleaned legacy comment
            utterance.lang = 'ko-KR'; // 한국어
            utterance.rate = 1.0; // 말하기 속도
            utterance.pitch = 1.0; // 음높이
            utterance.volume = 0.8; // 볼륨
            // cleaned legacy comment
            const voices = window.speechSynthesis.getVoices();
            const koreanVoice = voices.find(voice => voice.lang.includes('ko') ||
                voice.name.includes('Korean') ||
                voice.name.includes('한국'));
            if (koreanVoice) {
                utterance.voice = koreanVoice;
            }
            else {
            }
            // cleaned legacy comment
            utterance.onstart = () => {
            };
            utterance.onend = () => {
            };
            utterance.onerror = (event) => {
                console.error('음성 안내 오류:', event.error);
            };
            // cleaned legacy comment
            window.speechSynthesis.speak(utterance);
        }
        catch (error) {
            console.error('택배사명 음성 안내 오류:', error);
        }
    }, []);
    // cleaned legacy comment
    const getCourierNameByTrackingNumber = useCallback((trackingNumber) => {
        // cleaned legacy comment
        const allOrders = [
            ...courierData.kyungdong,
            ...courierData.cheonil,
            ...courierData.hanjin
        ];
        const matchedOrder = allOrders.find(order => (order.tracking_no || order.tracking_number || order.waybill_number || order.invoice_number) === trackingNumber);
        if (matchedOrder) {
            const courierName = matchedOrder.ship_comp || matchedOrder.courier_company || matchedOrder.courier || matchedOrder.delivery_company || matchedOrder.courier_name || '';
            // cleaned legacy comment
            const normalized = normalizeCourierName(courierName);
            if (normalized.includes('경동') || courierName.includes('KD') || courierName.includes('kdexp')) {
                return 'kyungdong';
            }
            else if (normalized.includes('천일') || courierName.includes('CHUNIL') || courierName.includes('1000')) {
                return 'cheonil';
            }
            else if (normalized.includes('한진') || courierName.includes('HANJIN') || courierName.includes('hanjin')) {
                return 'hanjin';
            }
            return courierName || 'courier';
        }
        // cleaned legacy comment
        if (courierData.kyungdong.some(order => (order.tracking_no || order.tracking_number) === trackingNumber)) {
            return 'kyungdong';
        }
        else if (courierData.cheonil.some(order => (order.tracking_no || order.tracking_number) === trackingNumber)) {
            return 'cheonil';
        }
        else if (courierData.hanjin.some(order => (order.tracking_no || order.tracking_number) === trackingNumber)) {
            return 'hanjin';
        }
        return 'courier';
    }, [courierData]);
    const handleTrackingNoChange = (e) => {
        const value = e.target.value;
        setTrackingNumber(value);
        setResult('');
        setError('');
        // cleaned legacy comment
        if (value.length >= 10) {
            setTimeout(() => {
                var _a;
                (_a = barcodeInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 100);
        }
    };
    const handleScannedBarcodeChange = (e) => {
        setBarcode(e.target.value);
        setResult('');
        setError('');
    };
    const handleTrackingNoKeyDown = (e) => {
        var _a;
        if (e.key === 'Enter') {
            (_a = barcodeInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const handleBarcodeKeyDown = (e) => {
        if (e.key === 'Enter') {
            // cleaned legacy comment
            if (!isValidating && !isProcessingRef.current) {
                validate();
            }
            else {
            }
        }
    };
    const validate = useCallback(async () => {
        const callId = Date.now() + Math.random();
        const currentCombination = `${tracking_number}_${barcode}`;
        if (!tracking_number || !barcode) {
            return;
        }
        // cleaned legacy comment
        if (lastProcessedRef.current === currentCombination) {
            return;
        }
        // cleaned legacy comment
        if (isValidating || isProcessingRef.current) {
            return;
        }
        // cleaned legacy comment
        isProcessingRef.current = true;
        lastProcessedRef.current = currentCombination;
        try {
            // cleaned legacy comment
            const saveHistory = async (trackingNumber, scannedBarcode, validationResult, errorMessage) => {
                var _a, _b;
                try {
                    // cleaned legacy comment
                    const allOrders = [
                        ...courierData.kyungdong,
                        ...courierData.cheonil,
                        ...courierData.hanjin
                    ];
                    const relatedOrder = allOrders.find(order => (order.tracking_no || order.tracking_number) === trackingNumber);
                    const historyData = {
                        tracking_number: trackingNumber,
                        scanned_barcode: scannedBarcode,
                        validation_result: validationResult,
                        error_message: errorMessage || undefined,
                        order_id: (relatedOrder === null || relatedOrder === void 0 ? void 0 : relatedOrder.id) ? parseInt(relatedOrder.id) : undefined,
                        product_code: (relatedOrder === null || relatedOrder === void 0 ? void 0 : relatedOrder.product_code) || undefined,
                        courier_company: (relatedOrder === null || relatedOrder === void 0 ? void 0 : relatedOrder.ship_comp) || undefined,
                        scan_timestamp: new Date().toISOString(),
                        worker_id: 'SCAN_USER',
                        worker_name: 'scan worker',
                        scan_device: navigator.userAgent.includes('Mobile') ? 'Mobile Device' : 'Desktop'
                    };
                    let dbSaveSuccess = false;
                    // cleaned legacy comment
                    try {
                        const response = await api.post(`/api/scan-validation/save`, historyData, {
                            timeout: 10000,
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) {
                            if ((_b = response.data.data) === null || _b === void 0 ? void 0 : _b.isDuplicate) {
                                dbSaveSuccess = true; // 중복이어도 DB에 이미 있으면 성공 처리
                            }
                            else {
                                dbSaveSuccess = true;
                            }
                        }
                        else {
                            console.warn('DB 스캔 이력 저장 실패:', response.data);
                        }
                    }
                    catch (apiError) {
                        console.warn('DB 저장 실패:', apiError);
                    }
                    // cleaned legacy comment
                    setScanHistory(prev => {
                        const newHistory = new Map(prev);
                        // cleaned legacy comment
                        const existingRecord = newHistory.get(trackingNumber);
                        if (validationResult === 'OK') {
                            // cleaned legacy comment
                            if (existingRecord && existingRecord.validation_result === 'NG') {
                            }
                            newHistory.set(trackingNumber, historyData);
                        }
                        else {
                            // cleaned legacy comment
                            if (existingRecord && existingRecord.validation_result === 'OK') {
                                return newHistory; // 기존 OK 기록 유지
                            }
                            else {
                                newHistory.set(trackingNumber, historyData);
                            }
                        }
                        return newHistory;
                    });
                    // cleaned legacy comment
                    setScannedTrackingNumbers(prev => {
                        const newSet = new Set(prev);
                        if (validationResult === 'OK') {
                            // OK인 경우 검증 목록 추가
                            newSet.add(trackingNumber);
                        }
                        else {
                            // cleaned legacy comment
                            const existingRecord = scanHistory.get(trackingNumber);
                            if (existingRecord && existingRecord.validation_result === 'OK') {
                                return newSet; // 기존 OK 상태 유지
                            }
                            else {
                                // cleaned legacy comment
                                if (newSet.has(trackingNumber)) {
                                    newSet.delete(trackingNumber);
                                }
                            }
                        }
                        return newSet;
                    });
                    // cleaned legacy comment
                    if (!dbSaveSuccess) {
                        try {
                            const key = getLocalStorageKey(selectedDate);
                            // cleaned legacy comment
                            const existingData = localStorage.getItem(key);
                            let historyArray = [];
                            if (existingData) {
                                historyArray = JSON.parse(existingData);
                            }
                            // cleaned legacy comment
                            const existingIndex = historyArray.findIndex(item => item.tracking_number === trackingNumber);
                            if (validationResult === 'OK') {
                                // cleaned legacy comment
                                if (existingIndex >= 0 && historyArray[existingIndex].validation_result === 'NG') {
                                    historyArray.splice(existingIndex, 1);
                                }
                                historyArray.push(historyData); // 새 OK 기록 추가
                            }
                            else {
                                // cleaned legacy comment
                                if (existingIndex >= 0 && historyArray[existingIndex].validation_result === 'OK') {
                                }
                                else {
                                    // cleaned legacy comment
                                    if (existingIndex >= 0) {
                                        historyArray[existingIndex] = historyData; // 기존 NG 기록 업데이트
                                    }
                                    else {
                                        historyArray.push(historyData); // 새 NG 기록 추가
                                    }
                                }
                            }
                            localStorage.setItem(key, JSON.stringify(historyArray));
                        }
                        catch (localError) {
                            console.error('로컬 스토리지 백업 저장 실패:', localError);
                        }
                    }
                    else {
                    }
                }
                catch (error) {
                    console.error('스캔 이력 저장 중 치명적 오류:', error);
                    // cleaned legacy comment
                    setScanHistory(prev => {
                        const newHistory = new Map(prev);
                        newHistory.set(trackingNumber, {
                            tracking_number: trackingNumber,
                            scanned_barcode: scannedBarcode,
                            validation_result: validationResult,
                            error_message: errorMessage || 'scan error',
                            scan_timestamp: new Date().toISOString(),
                            worker_id: 'SCAN_USER',
                            worker_name: 'scan worker',
                            scan_device: navigator.userAgent.includes('Mobile') ? 'Mobile Device' : 'Desktop'
                        });
                        return newHistory;
                    });
                }
            };
            // cleaned legacy comment
            if (tracking_number.length < 8) {
                setResult('NG');
                setError('운송장번호가 너무 짧습니다. (최소 8자)');
                playBeepSound();
                await saveHistory(tracking_number, barcode, 'NG', '운송장번호 형식 오류: 길이 부족');
                return;
            }
            // cleaned legacy comment
            if (barcode.length < 8) {
                setResult('NG');
                setError('바코드가 너무 짧습니다. (최소 8자)');
                playBeepSound();
                await saveHistory(tracking_number, barcode, 'NG', '바코드 형식 오류: 길이 부족');
                return;
            }
            setIsValidating(true);
            let retryCount = 0;
            const maxRetries = 2;
            const attemptValidation = async () => {
                var _a, _b, _c, _d, _e, _f;
                try {
                    const res = await api.post(`/api/validate-barcode`, {
                        tracking_number,
                        barcode
                    }, {
                        timeout: 10000,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    if (((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.is_valid) === true) {
                        setResult('OK');
                        message.success('바코드 검증 성공!');
                        // cleaned legacy comment
                        const courierName = getCourierNameByTrackingNumber(tracking_number);
                        speakCourierName(courierName);
                        await saveHistory(tracking_number, barcode, 'OK');
                        return true;
                    }
                    else {
                        const errorMsg = ((_c = res.data) === null || _c === void 0 ? void 0 : _c.message) || ((_d = res.data) === null || _d === void 0 ? void 0 : _d.error) || 'Barcode mismatch';
                        setResult('NG');
                        setError(normalizeKoreanText(errorMsg));
                        playBeepSound();
                        message.error(`바코드 검증 실패: ${normalizeKoreanText(errorMsg)}`);
                        await saveHistory(tracking_number, barcode, 'NG', errorMsg);
                        return true;
                    }
                }
                catch (err) {
                    retryCount++;
                    if (retryCount < maxRetries) {
                        console.warn(`검증 재시도 ${retryCount}/${maxRetries}:`, err);
                        await new Promise(resolve => setTimeout(resolve, 1000)); // 1초 대기
                        return attemptValidation();
                    }
                    // 최종 실패 처리
                    let errorMessage = '서버 검증 중 오류가 발생했습니다.';
                    if (api.isAxiosError(err)) {
                        const axiosError = err;
                        if (axiosError.code === 'ECONNABORTED') {
                            errorMessage = '서버 응답 시간 초과';
                        }
                        else if (((_e = axiosError.response) === null || _e === void 0 ? void 0 : _e.status) === 404) {
                            errorMessage = 'API 엔드포인트를 찾을 수 없습니다.';
                        }
                        else if (((_f = axiosError.response) === null || _f === void 0 ? void 0 : _f.status) && axiosError.response.status >= 500) {
                            errorMessage = '서버 내부 오류';
                        }
                        else if (!axiosError.response) {
                            errorMessage = '서버에 연결할 수 없습니다.';
                        }
                    }
                    setResult('NG');
                    setError(errorMessage);
                    playBeepSound();
                    message.error(errorMessage);
                    await saveHistory(tracking_number, barcode, 'NG', errorMessage);
                    return true;
                }
            };
            await attemptValidation();
            setIsValidating(false);
            setTimeout(() => {
                var _a;
                setTrackingNumber('');
                setBarcode('');
                setResult('');
                setError('');
                // cleaned legacy comment
                lastProcessedRef.current = '';
                (_a = trackingInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1500);
        }
        catch (error) {
            console.error(`VALIDATE 오류 [${callId}]:`, error);
            message.error('스캔 이력 저장에 실패했습니다.');
        }
        finally {
            isProcessingRef.current = false;
        }
    }, [tracking_number, barcode, isValidating, courierData.kyungdong, courierData.cheonil, courierData.hanjin, selectedDate, playBeepSound, getCourierNameByTrackingNumber, speakCourierName]);
    // cleaned legacy comment
    useEffect(() => {
        // cleaned legacy comment
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        // cleaned legacy comment
        if (tracking_number &&
            barcode &&
            tracking_number.length >= 10 &&
            barcode.length >= 10 &&
            !isValidating &&
            !isProcessingRef.current) {
            const currentCombination = `${tracking_number}_${barcode}`;
            // cleaned legacy comment
            if (lastProcessedRef.current === currentCombination) {
                return;
            }
            debounceTimer.current = setTimeout(() => {
                // cleaned legacy comment
                if (!isValidating && !isProcessingRef.current) {
                    validate();
                }
                else {
                }
            }, 800); // 800ms 디바운스
        }
        else {
        }
    }, [tracking_number, barcode, isValidating, validate]);
    const courierColors = {
        kyungdong: { bg: '#FF6B35', header: '#E55A2B' },
        cheonil: { bg: '#4ECDC4', header: '#3DBDB4' },
        hanjin: { bg: '#45B7D1', header: '#3A9BC1' }
    };
    return (_jsxs("div", { style: {
            height: '100vh',
            backgroundColor: '#f8f9fa',
            padding: '15px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }, children: [_jsxs(Container, { fluid: true, style: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0'
                }, children: [_jsxs("div", { style: {
                            height: '35%',
                            marginBottom: '15px',
                            display: 'flex',
                            gap: '15px'
                        }, children: [_jsxs("div", { style: {
                                    flex: '1',
                                    backgroundColor: 'white',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    padding: '25px',
                                    minWidth: '300px'
                                }, children: [_jsx("h2", { style: {
                                            fontSize: 'clamp(20px, 3vw, 28px)',
                                            fontWeight: 'bold',
                                            marginBottom: '20px',
                                            textAlign: 'center',
                                            color: '#495057'
                                        }, children: "\uC6B4\uC1A1\uC7A5\uBC88\uD638 \uBC14\uCF54\uB4DC \uC2A4\uCE94" }), _jsx(Form.Control, { type: "text", value: tracking_number, onChange: handleTrackingNoChange, onKeyDown: handleTrackingNoKeyDown, placeholder: "\uC6B4\uC1A1\uC7A5\uBC88\uD638\uB97C \uC2A4\uCE94\uD558\uC138\uC694", autoFocus: true, ref: trackingInputRef, style: {
                                            fontSize: 'clamp(16px, 2.5vw, 22px)',
                                            height: 'clamp(50px, 8vh, 70px)',
                                            textAlign: 'center',
                                            border: '3px solid #dee2e6',
                                            borderRadius: '10px',
                                            fontWeight: '500'
                                        }, disabled: isValidating })] }), _jsxs("div", { style: {
                                    flex: '1',
                                    backgroundColor: 'white',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    padding: '25px',
                                    minWidth: '300px'
                                }, children: [_jsx("h2", { style: {
                                            fontSize: 'clamp(20px, 3vw, 28px)',
                                            fontWeight: 'bold',
                                            marginBottom: '20px',
                                            textAlign: 'center',
                                            color: '#495057'
                                        }, children: "\uBC15\uC2A4 \uBC14\uCF54\uB4DC \uC2A4\uCE94" }), _jsx(Form.Control, { type: "text", value: barcode, onChange: handleScannedBarcodeChange, onKeyDown: handleBarcodeKeyDown, placeholder: "\uBC15\uC2A4 \uBC14\uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC138\uC694", ref: barcodeInputRef, style: {
                                            fontSize: 'clamp(16px, 2.5vw, 22px)',
                                            height: 'clamp(50px, 8vh, 70px)',
                                            textAlign: 'center',
                                            border: '3px solid #dee2e6',
                                            borderRadius: '10px',
                                            fontWeight: '500'
                                        }, disabled: isValidating })] }), _jsx("div", { style: {
                                    flex: '0.8',
                                    backgroundColor: result === 'OK' ? '#28a745' : result === 'NG' ? '#dc3545' : '#6c757d',
                                    borderRadius: '15px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: 'white',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                                    padding: '20px',
                                    minWidth: '200px',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }, children: result ? (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                                                fontSize: 'clamp(40px, 8vw, 80px)',
                                                marginBottom: '10px',
                                                animation: result === 'OK' ? 'pulse 1s ease-in-out' : 'shake 0.5s ease-in-out'
                                            }, children: result === 'OK' ? 'OK' : 'NG' }), _jsx("div", { style: {
                                                textAlign: 'center',
                                                fontSize: 'clamp(42px, 6vw, 60px)',
                                                fontWeight: 'bold',
                                                marginBottom: '5px'
                                            }, children: result === 'OK' ? 'SUCCESS' : 'FAILED' }), _jsx("div", { style: {
                                                fontSize: 'clamp(36px, 4.5vw, 48px)',
                                                textAlign: 'center',
                                                opacity: 0.9
                                            }, children: result === 'OK' ? '바코드 일치' : '바코드 불일치' }), error && result === 'NG' && (_jsx("div", { style: {
                                                fontSize: 'clamp(10px, 1.2vw, 14px)',
                                                marginTop: '8px',
                                                opacity: 0.8,
                                                textAlign: 'center'
                                            }, children: error }))] })) : (_jsxs("div", { style: { textAlign: 'center', opacity: 0.8 }, children: [_jsx("div", { style: {
                                                fontSize: 'clamp(30px, 6vw, 50px)',
                                                marginBottom: '10px',
                                                animation: 'spin 2s linear infinite'
                                            }, children: "\uB300\uAE30\uC911" }), _jsx("div", { style: {
                                                fontSize: 'clamp(28px, 4vw, 36px)',
                                                fontWeight: 'bold'
                                            }, children: "WAITING" }), _jsx("div", { style: {
                                                fontSize: 'clamp(20px, 3vw, 28px)',
                                                marginTop: '5px'
                                            }, children: "\uBC14\uCF54\uB4DC\uB97C \uC2A4\uCE94\uD574 \uC8FC\uC138\uC694" })] })) })] }), _jsxs("div", { style: {
                            marginBottom: '15px',
                            backgroundColor: 'white',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px'
                        }, children: [_jsxs("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '15px',
                                    flexWrap: 'nowrap' // 레이아웃 고정을 위해 nowrap 설정
                                }, children: [_jsx("label", { style: {
                                            fontSize: 'clamp(16px, 2.5vw, 20px)',
                                            fontWeight: 'bold',
                                            color: '#495057',
                                            whiteSpace: 'nowrap',
                                            minWidth: 'fit-content' // 버튼 크기 고정
                                        }, children: "\uCD9C\uD558\uC77C\uC790 \uC120\uD0DD:" }), _jsx("div", { style: {
                                            width: '200px',
                                            minWidth: '200px' // DatePicker ?ш린 怨좎젙
                                        }, children: _jsx(DatePicker, { selected: selectedDate, onChange: handleDateChange, dateFormat: "yyyy-MM-dd", maxDate: new Date(), showYearDropdown: true, showMonthDropdown: true, dropdownMode: "select", className: "form-control custom-datepicker", popperProps: { strategy: 'fixed' }, popperPlacement: "bottom-start" }) }), _jsxs("div", { style: {
                                            fontSize: 'clamp(14px, 2vw, 16px)',
                                            color: '#6c757d',
                                            fontStyle: 'italic',
                                            whiteSpace: 'nowrap'
                                        }, children: ["\uC120\uD0DD\uD55C \uB0A0\uC9DC: ", selectedDate.toLocaleDateString('ko-KR')] }), isLoadingData && (_jsx("div", { style: {
                                            fontSize: 'clamp(14px, 2vw, 16px)',
                                            color: '#007bff',
                                            fontStyle: 'italic',
                                            whiteSpace: 'nowrap'
                                        }, children: "\uB370\uC774\uD130 \uB85C\uB529 \uC911..." }))] }), _jsxs("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap',
                                    gap: '15px'
                                }, children: [_jsxs("div", { style: { display: 'flex', gap: '8px', flexWrap: 'wrap' }, children: [_jsx("button", { onClick: () => setSelectedDate(new Date()), style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: '#007bff',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap'
                                                }, children: "\uC624\uB298" }), _jsx("button", { onClick: () => {
                                                    const yesterday = new Date();
                                                    yesterday.setDate(yesterday.getDate() - 1);
                                                    setSelectedDate(yesterday);
                                                }, style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: '#6c757d',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap'
                                                }, children: "\uC5B4\uC81C" }), _jsx("button", { onClick: () => {
                                                    const lastWeek = new Date();
                                                    lastWeek.setDate(lastWeek.getDate() - 7);
                                                    setSelectedDate(lastWeek);
                                                }, style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: '#28a745',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap'
                                                }, children: "1\uC8FC\uC77C" }), _jsx("button", { onClick: () => {
                                                    // cleaned legacy comment
                                                    setScanHistory(new Map());
                                                    setScannedTrackingNumbers(new Set());
                                                    // cleaned legacy comment
                                                    fetchOrdersByDate(selectedDate);
                                                    message.info('DB 우선순위로 데이터를 다시 불러옵니다.');
                                                }, disabled: isLoadingData, style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: isLoadingData ? '#ccc' : '#ffc107',
                                                    color: isLoadingData ? '#666' : '#212529',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: isLoadingData ? 'not-allowed' : 'pointer',
                                                    whiteSpace: 'nowrap'
                                                }, children: "\uC0C8\uB85C\uACE0\uCE68" }), _jsx("button", { onClick: () => {
                                                    cleanupOldLocalData();
                                                    message.info('로컬 스토리지 정리 완료 (일주일 이상 지난 데이터 삭제)');
                                                }, style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: '#dc3545',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap'
                                                }, children: "\uB85C\uCEEC \uC815\uB9AC" }), _jsx("button", { onClick: () => {
                                                    // cleaned legacy comment
                                                    if (window.speechSynthesis) {
                                                        speakCourierName('kyungdong');
                                                        // cleaned legacy comment
                                                        setTimeout(() => speakCourierName('cheonil'), 3000);
                                                        setTimeout(() => speakCourierName('hanjin'), 6000);
                                                        message.info('음성 테스트 시작: kyungdong / cheonil / hanjin');
                                                    }
                                                    else {
                                                        message.warning('이 브라우저에서는 음성 합성을 지원하지 않습니다.');
                                                    }
                                                }, style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: '#17a2b8',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap'
                                                }, children: "\uC74C\uC131 \uD14C\uC2A4\uD2B8" }), _jsx("button", { onClick: () => setShowFailedOnly(prev => !prev), style: {
                                                    padding: '8px 12px',
                                                    fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                    backgroundColor: showFailedOnly ? '#dc3545' : '#6c757d',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    fontWeight: showFailedOnly ? 'bold' : 'normal'
                                                }, children: showFailedOnly ? '미스캔만 보기 ON' : '미스캔만 보기' }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }, children: [_jsx("input", { type: "text", value: trackingSearch, onChange: e => setTrackingSearch(e.target.value), placeholder: "\uC6B4\uC1A1\uC7A5\uBC88\uD638 \uC870\uD68C", style: {
                                                            padding: '8px 12px',
                                                            fontSize: 'clamp(12px, 1.5vw, 14px)',
                                                            border: '2px solid #6f42c1',
                                                            borderRadius: '6px',
                                                            width: '180px',
                                                            outline: 'none'
                                                        } }), trackingSearch && (_jsx("button", { onClick: () => setTrackingSearch(''), style: {
                                                            padding: '8px 10px',
                                                            fontSize: '13px',
                                                            backgroundColor: '#6c757d',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            cursor: 'pointer',
                                                            whiteSpace: 'nowrap'
                                                        }, children: "\uCD08\uAE30\uD654" }))] })] }), !isLoadingData && (_jsxs("div", { style: {
                                            display: 'flex',
                                            gap: '10px',
                                            flexWrap: 'wrap',
                                            alignItems: 'center'
                                        }, children: [_jsx("div", { style: {
                                                    fontSize: 'clamp(13px, 1.8vw, 15px)',
                                                    color: '#495057',
                                                    backgroundColor: '#f8f9fa',
                                                    padding: '8px 12px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #dee2e6',
                                                    whiteSpace: 'nowrap'
                                                }, children: (() => {
                                                    const totalOrders = Object.values(courierData).reduce((sum, orders) => sum + orders.length, 0);
                                                    // cleaned legacy comment
                                                    const kyungdongScanned = courierData.kyungdong.filter((order) => {
                                                        const trackingNo = order.tracking_no || order.tracking_number || '';
                                                        const { isScanned } = isTrackingNumberScanned(trackingNo);
                                                        return isScanned;
                                                    }).length;
                                                    const cheonilScanned = courierData.cheonil.filter((order) => {
                                                        const trackingNo = order.tracking_no || order.tracking_number || '';
                                                        const { isScanned } = isTrackingNumberScanned(trackingNo);
                                                        return isScanned;
                                                    }).length;
                                                    const hanjinScanned = courierData.hanjin.filter((order) => {
                                                        const trackingNo = order.tracking_no || order.tracking_number || '';
                                                        const { isScanned } = isTrackingNumberScanned(trackingNo);
                                                        return isScanned;
                                                    }).length;
                                                    // cleaned legacy comment
                                                    const totalScanned = kyungdongScanned + cheonilScanned + hanjinScanned;
                                                    return `총 ${totalScanned}/${totalOrders}건 스캔완료 (경동: ${kyungdongScanned}/${courierData.kyungdong.length}, 천일: ${cheonilScanned}/${courierData.cheonil.length}, 한진: ${hanjinScanned}/${courierData.hanjin.length})`;
                                                })() }), _jsx("div", { style: {
                                                    fontSize: 'clamp(12px, 1.6vw, 14px)',
                                                    color: '#6c757d',
                                                    backgroundColor: '#e9ecef',
                                                    padding: '6px 10px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #ced4da',
                                                    whiteSpace: 'nowrap'
                                                }, children: (() => {
                                                    const stats = getLocalStorageStats();
                                                    const currentHistorySize = scanHistory.size;
                                                    if (currentHistorySize > 0) {
                                                        return `현재 세션: DB+로컬 ${currentHistorySize}건 | 로컬 보관 ${stats.totalDays}일 ${stats.totalRecords}건(일주일간 보관)`;
                                                    }
                                                    else {
                                                        return `로컬 보관 ${stats.totalDays}일 ${stats.totalRecords}건(일주일간 보관) | DB 우선 로딩`;
                                                    }
                                                })() })] }))] })] }), _jsx("div", { style: {
                            flex: '1',
                            display: 'flex',
                            gap: '15px',
                            minHeight: '0'
                        }, children: Object.entries(courierData).map(([courierName, orders]) => (_jsxs("div", { style: {
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundColor: 'white',
                                borderRadius: '15px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                overflow: 'hidden',
                                minWidth: '300px'
                            }, children: [_jsxs("div", { style: {
                                        backgroundColor: courierColors[courierName].header,
                                        color: 'white',
                                        padding: '15px 20px',
                                        textAlign: 'center',
                                        fontSize: 'clamp(16px, 2.5vw, 22px)',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }, children: [_jsx("span", { children: courierName }), _jsx("span", { style: {
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                padding: '4px 12px',
                                                borderRadius: '20px',
                                                fontSize: 'clamp(14px, 2vw, 18px)'
                                            }, children: (() => {
                                                // cleaned legacy comment
                                                const scannedCount = orders.filter((order) => {
                                                    const trackingNo = order.tracking_no || order.tracking_number || '';
                                                    const { isScanned } = isTrackingNumberScanned(trackingNo);
                                                    return isScanned;
                                                }).length;
                                                return `${scannedCount}/${orders.length}건`;
                                            })() })] }), _jsx("div", { style: {
                                        flex: '1',
                                        overflow: 'auto',
                                        backgroundColor: '#fafafa'
                                    }, children: isLoadingData ? (_jsx("div", { style: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '200px',
                                            fontSize: 'clamp(16px, 2.5vw, 20px)',
                                            color: '#6c757d'
                                        }, children: "\uB85C\uB529 \uC911..." })) : (_jsxs(Table, { striped: true, bordered: true, hover: true, size: "sm", style: {
                                            margin: '0',
                                            fontSize: 'clamp(13px, 1.5vw, 16px)',
                                            backgroundColor: 'white'
                                        }, children: [_jsx("thead", { style: {
                                                    position: 'sticky',
                                                    top: '0',
                                                    backgroundColor: courierColors[courierName].bg,
                                                    color: 'white',
                                                    zIndex: 10
                                                }, children: _jsxs("tr", { children: [_jsx("th", { style: {
                                                                width: '25%',
                                                                padding: 'clamp(8px, 1.5vh, 12px)',
                                                                fontSize: 'clamp(12px, 1.5vw, 15px)',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }, children: "\uC6B4\uC1A1\uC7A5\uBC88\uD638" }), _jsx("th", { style: {
                                                                width: '20%',
                                                                padding: 'clamp(8px, 1.5vh, 12px)',
                                                                fontSize: 'clamp(12px, 1.5vw, 15px)',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }, children: "\uC0C1\uD488\uCF54\uB4DC" }), _jsx("th", { style: {
                                                                width: '35%',
                                                                padding: 'clamp(8px, 1.5vh, 12px)',
                                                                fontSize: 'clamp(12px, 1.5vw, 15px)',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }, children: "\uC0C1\uD488\uBA85" }), _jsx("th", { style: {
                                                                width: '10%',
                                                                padding: 'clamp(8px, 1.5vh, 12px)',
                                                                fontSize: 'clamp(12px, 1.5vw, 15px)',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }, children: "\uC218\uB7C9" }), _jsx("th", { style: {
                                                                width: '10%',
                                                                padding: 'clamp(8px, 1.5vh, 12px)',
                                                                fontSize: 'clamp(12px, 1.5vw, 15px)',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }, children: "\uC0C1\uD0DC" })] }) }), _jsx("tbody", { children: orders.length > 0 ? (orders
                                                    .filter((order) => {
                                                    if (!trackingSearch.trim())
                                                        return true;
                                                    const tn = order.tracking_no || order.tracking_number || order.waybill_number || order.invoice_number || '';
                                                    return tn.includes(trackingSearch.trim());
                                                })
                                                    .filter((order) => {
                                                    if (!showFailedOnly)
                                                        return true;
                                                    const tn = order.tracking_no || order.tracking_number || order.waybill_number || order.invoice_number || '';
                                                    const { isScanned } = isTrackingNumberScanned(tn);
                                                    return !isScanned;
                                                })
                                                    .map((order, index) => {
                                                    const trackingNo = order.tracking_no || order.tracking_number || order.waybill_number || order.invoice_number || '';
                                                    const { isScanned, isFailed } = isTrackingNumberScanned(trackingNo);
                                                    return (_jsxs("tr", { style: {
                                                            backgroundColor: isScanned ? '#d4edda' : isFailed ? '#f8d7da' : index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                                                        }, children: [_jsx("td", { style: {
                                                                    padding: 'clamp(6px, 1vh, 10px)',
                                                                    fontSize: 'clamp(12px, 1.3vw, 14px)',
                                                                    wordBreak: 'break-all',
                                                                    fontFamily: 'monospace',
                                                                    fontWeight: '500'
                                                                }, children: trackingNo }), _jsx("td", { style: {
                                                                    padding: 'clamp(6px, 1vh, 10px)',
                                                                    fontSize: 'clamp(12px, 1.3vw, 14px)',
                                                                    textAlign: 'center'
                                                                }, children: order.product_code || order.item_code || order.sku || '-' }), _jsx("td", { style: {
                                                                    padding: 'clamp(6px, 1vh, 10px)',
                                                                    fontSize: 'clamp(12px, 1.3vw, 14px)',
                                                                    wordBreak: 'break-word',
                                                                    lineHeight: '1.3'
                                                                }, children: order.product_name || order.item_name || order.product_title || '-' }), _jsx("td", { style: {
                                                                    padding: 'clamp(6px, 1vh, 10px)',
                                                                    fontSize: 'clamp(12px, 1.3vw, 14px)',
                                                                    textAlign: 'center',
                                                                    fontWeight: 'bold'
                                                                }, children: order.quantity || order.qty || order.amount || '-' }), _jsx("td", { style: {
                                                                    padding: 'clamp(6px, 1vh, 10px)',
                                                                    fontSize: 'clamp(12px, 1.3vw, 14px)',
                                                                    textAlign: 'center',
                                                                    fontWeight: 'bold',
                                                                    color: isScanned ? '#28a745' : isFailed ? '#dc3545' : '#6c757d'
                                                                }, children: isScanned ? '검증성공' : isFailed ? '검증실패' : '-' })] }, index));
                                                })) : (_jsx("tr", { children: _jsx("td", { colSpan: 5, style: {
                                                            textAlign: 'center',
                                                            padding: 'clamp(20px, 4vh, 40px)',
                                                            color: '#6c757d',
                                                            fontSize: 'clamp(16px, 2vw, 20px)',
                                                            fontStyle: 'italic'
                                                        }, children: trackingSearch.trim()
                                                            ? `"${trackingSearch}" 운송장번호를 찾을 수 없습니다`
                                                            : `${selectedDate.toLocaleDateString('ko-KR')} ${courierName} 데이터가 없습니다` }) })) })] })) })] }, courierName))) })] }), _jsx("style", { children: `
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        /* cleaned legacy comment */
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 10px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        
        /* 諛섏쓳??議곗젙 */
        @media (max-width: 1200px) {
          .container-fluid {
            padding: 10px !important;
          }
        }
        
        @media (max-width: 768px) {
          .main-scan-area {
            flex-direction: column !important;
            height: auto !important;
          }
          
          .courier-tables {
            flex-direction: column !important;
            height: auto !important;
          }
        }

        /* cleaned legacy comment */
        .react-datepicker-wrapper {
          width: 200px !important;
        }

        .react-datepicker-popper {
          z-index: 9999 !important;
        }
        
        .react-datepicker__input-container input {
          font-size: clamp(14px, 2vw, 18px) !important;
          padding: 10px 15px !important;
          border: 2px solid #dee2e6 !important;
          border-radius: 8px !important;
          text-align: center !important;
          font-weight: 500 !important;
        }
        
        .react-datepicker__input-container input:focus {
          border-color: #80bdff !important;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
          outline: none !important;
        }
      ` })] }));
};
export default InvoiceValidation;
